import React from 'react';
import Text from '@service-victoria/component-library/components/Text';
import Page from '@service-victoria/component-library/components/Page';
import styled from 'styled-components';
import { constants } from 'utils';
import bannerImg from 'assets/melbourne-city-at-night.png';

const PageWrapper = styled(Page)``;

export default function QuotaExceeded() {
  return (
    <PageWrapper
      title={constants.Page.title}
      showFooter
      breadCrumbs={constants.breadCrumbs}
      imgUrl={bannerImg}
      loading={false}
      opacityBetweenLoading={0}>
      <Text.Heading.H2 style={{ fontWeight: 'bold' }}>ALLOCATION EXHAUSTED</Text.Heading.H2>
      <Text.Body>
        Unfortunately due to high demand, the allocation of 40,000 vouchers for the Melbourne Travel
        Voucher Scheme has now been exhausted.
      </Text.Body>
      <Text.Body>
        We apologise for any inconvenience and thank you for your interest and continued support of
        tourism businesses in Victoria.
      </Text.Body>
    </PageWrapper>
  );
}
